module.exports = __webpack_public_path__ + "img/giftParty.31acb94b.png";